module.exports = __webpack_public_path__ + "img/dojo.56a07f49.png";